module.exports = __webpack_public_path__ + "img/supermarket.affeca09.png";